<template>
    <view-card :headline="'선택업체정보'" titleCols="auto" titleAlign="baseline">
        <template slot="buttons">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn @click="contract" small color="primary" style="font-weight:900;" :disabled="!interior">선택업체로 안심계약</v-btn>
            </v-col>
        </template>
        <v-data-table v-if="interior" :headers="interiorHeader" :items="[interior]" hide-default-footer disable-sort>
            <template v-slot:item.reassurance="{ item }"> {{ item.scope.includes("reassurance") ? "안심" : "일반" }} </template>
            <template v-slot:item.phone="{ item }"> {{ item.phone.phoneNumberFormat() }} </template>
            <template v-slot:item.distance="{ item }"> {{ item.distance ? Math.round(item.distance / 1000) + " km" : "-" }} </template>
            <template v-slot:item.portfolios="{ item }">
                <v-btn :to="`/partners/interior/${item._id}`" target="_blank" text><v-icon>mdi-home</v-icon></v-btn>
            </template>
            <template v-slot:item.lastEstimateAmount="{ item }">
                <template v-if="item.estimates.length">
                    {{ Math.round(calculateTotalAmount(item.estimates[item.estimates.length - 1])).format() }}
                </template>
            </template>
            <template v-slot:item.estimates="{ item }">
                <v-btn v-for="(estimate, i) in item.estimates" :key="`button-${i}`" @click="$emit('showEstimate', estimate)" small color="primary" class="ma-2">견적{{ i + 1 }}차</v-btn>
            </template>
            <template v-slot:item.cancelSelect="{ item }">
                <v-btn @click="$emit('saveInterior', { _id: null })" small color="warning" :disabled="!isAdmin">선택취소</v-btn>
            </template>
        </v-data-table>
        <v-row v-else justify="center">선택된 업체가 없습니다.</v-row>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
import { calculateTotalAmount } from "@/plugins/calculateEstimateTotalAmount";

export default {
    components: { viewCard },
    props: {
        _inquiry: { type: String, default: null },
        interior: { type: Object, default: null },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            interiorHeader: [
                {
                    text: "안심계약",
                    value: "reassurance",
                    width: 90,
                },
                {
                    text: "업체명",
                    value: "meta.companyName",
                    width: 120,
                },
                {
                    text: "대표자",
                    value: "name",
                    width: 120,
                },
                {
                    text: "전화번호",
                    value: "phone",
                    width: 140,
                },
                {
                    text: "거리",
                    value: "distance",
                    width: 80,
                },
                {
                    text: "응답평균시간",
                    value: "averageReplyTime",
                    width: 120,
                },
                {
                    text: "포트폴리오",
                    value: "portfolios",
                    width: 100,
                },
                {
                    text: "진행건수",
                    value: "selectedNumber",
                    width: 100,
                },
                {
                    text: "최종견적금액",
                    value: "lastEstimateAmount",
                    width: 120,
                },
                {
                    text: "답변시간",
                    value: "lastEstimateReplyTime",
                    width: 100,
                },
                {
                    text: "견적서",
                    value: "estimates",
                    width: 220,
                },
                {
                    text: "선택취소",
                    value: "cancelSelect",
                    width: 100,
                },
            ],
        };
    },
    methods: {
        calculateTotalAmount,
        contract() {
            const { hrefContract } = this;
            this.$emit("save", { inquiryResultType: "안심계약", status: "계약진행중" });
            this.$nextTick(() => {
                this.$router.push(hrefContract);
            });
        },
    },
    computed: {
        hrefContract() {
            return `/console/contracts/write?_inquiry=${this.$props._inquiry}`;
        },
    },
};
</script>
